import { render, staticRenderFns } from "./business-select.vue?vue&type=template&id=4b4300ce&scoped=true&"
import script from "./business-select.vue?vue&type=script&lang=js&"
export * from "./business-select.vue?vue&type=script&lang=js&"
import style0 from "./business-select.vue?vue&type=style&index=0&id=4b4300ce&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b4300ce",
  null
  
)

export default component.exports